<template>
  <div class="page">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "layout",
};
</script>

<style lang="scss" scoped>
</style>


